function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 10,
  r: 9.5,
  fill: "white",
  stroke: "#B8B8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.541 12.2422H9.45898L8.87305 14H7.00391L10.1797 5.46875H11.8086L15.002 14H13.1328L12.541 12.2422ZM9.93359 10.8184H12.0664L10.9941 7.625L9.93359 10.8184Z",
  fill: "#858585"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 56,
  r: 9.5,
  fill: "#B8B8B8",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.92969 60V51.4688H10.918C11.9531 51.4688 12.7383 51.668 13.2734 52.0664C13.8086 52.4609 14.0762 53.041 14.0762 53.8066C14.0762 54.2246 13.9688 54.5938 13.7539 54.9141C13.5391 55.2305 13.2402 55.4629 12.8574 55.6113C13.2949 55.7207 13.6387 55.9414 13.8887 56.2734C14.1426 56.6055 14.2695 57.0117 14.2695 57.4922C14.2695 58.3125 14.0078 58.9336 13.4844 59.3555C12.9609 59.7773 12.2148 59.9922 11.2461 60H7.92969ZM9.6875 56.2852V58.5879H11.1934C11.6074 58.5879 11.9297 58.4902 12.1602 58.2949C12.3945 58.0957 12.5117 57.8223 12.5117 57.4746C12.5117 56.6934 12.1074 56.2969 11.2988 56.2852H9.6875ZM9.6875 55.043H10.9883C11.875 55.0273 12.3184 54.6738 12.3184 53.9824C12.3184 53.5957 12.2051 53.3184 11.9785 53.1504C11.7559 52.9785 11.4023 52.8926 10.918 52.8926H9.6875V55.043Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11,
  y1: 19.5,
  x2: 11,
  y2: 46,
  stroke: "#B8B8B8",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 0,
  y: 19.5,
  width: 22,
  height: 48.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgTripInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 68,
    viewBox: "0 0 22 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripInactive);
export default __webpack_public_path__ + "static/media/trip-inactive.a9c82ec2ca661f82d3f5419f6f56df8a.svg";
export { ForwardRef as ReactComponent };